// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SymbolPage_wrapper_20t60"};